//
import {getPageOpList, getSavePageOp, getUpdatePageOp, getDeletePageOp} from './../api';
import { Message } from 'element-ui';
const pageOp = {
  namespaced: true,
  state: {
    successCode:200,
    respCode:-1,
    respObj:null,
    add:{},
    edit:{},
    view:{},
    dataList:null,
    total:0,
    rootMenu:null,
    allPageList:null,
    addPageList:null,
    editPageList:null,
    deletePageList:null,
  },
  mutations: {
    GET_PAGE_OP_LIST(state,data){
      state.total = data.total;
      state.allPageList = data.obj || [];
    },
    GET_SAVE_PAGE_OP(state,data){
      state.addPageList = data
    },
    GET_UPDATE_PAGE_OP(state,data){
      state.editPageList = data
    },
    GET_DELETE_PAGE_OP(state,data){
      state.deletePageList = data
    }
  },
  actions: {
    //
    async getPageOpList({commit}, obj){
      let resp = await getPageOpList(obj);
      commit('GET_PAGE_OP_LIST', resp);
    },
    async getSavePageOp({commit}, obj){
      let resp = await getSavePageOp(obj);
      commit('GET_SAVE_PAGE_OP', resp);
    },
    async getUpdatePageOp({commit}, obj){
      let resp = await getUpdatePageOp(obj);
      commit('GET_UPDATE_PAGE_OP', resp);
    },
    async getDeletePageOp({commit}, obj){
      let resp = await getDeletePageOp(obj);
      commit('GET_DELETE_PAGE_OP', resp);
    },

  }
}

export default pageOp



// WEBPACK FOOTER //
// ./src/page/auth/pageOp/store/pageOp.store.js